import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { supabase, getSession } from './utils/supabase';
import TopBar from './components/TopBar';
import BottomBar from './components/BottomBar';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import Auth from './pages/Auth';
import Todo from './pages/Todo';
import Library from './pages/Library';
import Profile from './pages/Profile';
import Announcement from './pages/Announcement';
import AnnouncementDetail from './pages/AnnouncementDetail';

function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      const { session } = await getSession();
      setSession(session);
      setLoading(false);
    };
    initAuth();

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <div className="min-h-screen bg-gray-50">
        <TopBar />
        <main className="pb-16 lg:pb-0">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/auth/callback" element={<Navigate to="/" replace />} />
            <Route path="/todo" element={<Todo />} />
            <Route path="/library" element={<Library />} />
            <Route path="/announcements" element={<Announcement />} />
            <Route path="/announcements/:id" element={<AnnouncementDetail />} />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route path="/profile/:id" element={<Profile />} />
            <Route
              path="/profile/todo"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
          </Routes>
        </main>
        <BottomBar />
      </div>
    </BrowserRouter>
  );
}

export default App;
